// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3kxvg","author":"Table_author__1C1YA","authorImage":"Table_authorImage__e0Qav","unreadRow":"Table_unreadRow__2fApc"};